import { UnreadCountDTO } from "entities/dto/UnreadCountDTO";

/*
 * The counts the socket wrote straight into the unread-counts cache, by
 * merchant, with when they were written. An HTTP read of the counts that
 * started before such a write answers for an older moment: the write is
 * kept for that merchant instead of the older answer.
 */

interface SocketUnreadWrite {
  count: UnreadCountDTO;
  writtenAt: number;
}

const latestSocketWrites = new Map<number, SocketUnreadWrite>();

export const recordSocketUnreadCount = (count: UnreadCountDTO): void => {
  latestSocketWrites.set(count.merchant_id, { count, writtenAt: Date.now() });
};

// The HTTP counts, with every merchant the socket wrote after the request
// started kept at the socket's newer counts.
export const keepNewerSocketCounts = (
  counts: UnreadCountDTO[],
  requestedAt: number
): UnreadCountDTO[] =>
  counts.map((count) => {
    const write = latestSocketWrites.get(count.merchant_id);
    return write && write.writtenAt > requestedAt ? write.count : count;
  });
